import React from 'react';
import PropTypes from 'prop-types';
import MultiLineTextArea from 'bento-ordering/base/components/MultiLineTextArea';

/**
 * This is textarea component that needs to be used
 * as a component prop in redux-form.
 */
const MultiLineTextAreaField = props => {
  const {
    input,
    placeholder,
    maxLength,
    defaultValue,
    dataTestId,
    disabled = false
  } = props;
  return (
    <MultiLineTextArea
      placeholder={placeholder}
      value={input.value}
      defaultValue={defaultValue}
      onChange={input.onChange}
      maxLength={maxLength}
      dataTestId={dataTestId}
      disabled={disabled}
    />
  );
};

MultiLineTextAreaField.propTypes = {
  input: PropTypes.object,
  placeholder: PropTypes.string,
  maxLength: PropTypes.string,
  defaultValue: PropTypes.string,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool
};

export default MultiLineTextAreaField;
